import {Provider} from 'react-redux';
import {IS_CLIENT} from './constant';
import {getStore, IReduxState} from './store';
import {IKwAppContext, IKwAppProps, IKwApp, PStore} from './type';

interface WrapperProps extends IKwAppProps {
  initialProps: IKwAppProps;
  initialState: IReduxState;
  initialStore: PStore;
}

const withRedux = (AppComponent: IKwApp) => {
  const Wrapper = ({
    initialState,
    initialProps,
    initialStore,
    ...props
  }: WrapperProps) => {
    return (
      <Provider store={IS_CLIENT ? getStore(initialState) : initialStore}>
        <AppComponent {...initialProps} {...props} />
      </Provider>
    );
  };

  const appInitialProps = AppComponent.getInitialProps;
  Wrapper.getInitialProps = async (appContext: IKwAppContext) => {
    const store = getStore();
    appContext.ctx.store = store;
    const initialProps = await appInitialProps(appContext);

    return {
      initialProps,
      initialState: IS_CLIENT ? undefined : serializeState(store.getState()),
      initialStore: store,
    };
  };

  return Wrapper;
};

const serializeState = (state: IReduxState) => ({
  ...state,
  common: {
    ...state.common,
    i18next: undefined,
    headers: undefined,
  },
});

export default withRedux;
